import { StandardsList } from "./StandardsList.component";

export { StandardsList };
